// services/appointmentService.js
import axiosInstance from "./AxiosInstance";

// Get booked appointments with filters
export const getBookedAppointments = async (date, doctor_id = null) => {
  const payload = {
    date: date,
    is_payment: "Yes",
    is_confirmed: "Yes"
  };
  
  // Add doctor_id only if provided
  if (doctor_id) {
    payload.doctor_id = doctor_id;
  }
  
  return axiosInstance.post("/receptionist/appointments", payload);
};



// Format booked appointments (similar to formatNotes)
export function formatBookedAppointments(responseData) {
  if (!responseData) return [];
  
  // If responseData is an array
  if (Array.isArray(responseData)) {
    return responseData.map(appointment => ({
      ...appointment,
      id: appointment.appointment_id || appointment.id,
      // Add any additional formatting here
    }));
  }
  
  // If responseData is an object with nested data
  let appointments = [];
  const dataToProcess = responseData.data || responseData;
  
  if (Array.isArray(dataToProcess)) {
    appointments = dataToProcess;
  } else {
    for (let key in dataToProcess) {
      if (dataToProcess.hasOwnProperty(key)) {
        appointments.push({
          ...dataToProcess[key],
          id: dataToProcess[key].appointment_id || dataToProcess[key].id || key,
        });
      }
    }
  }
  
  // Apply your existing formatBookedAppointments logic here
  return formatAppointmentsData(appointments);
}

// Your existing formatting logic
function formatAppointmentsData(data) {
  if (!Array.isArray(data)) return [];
  
  return data
    .filter(item => item.appointment_id !== null)
    .map(item => {
      const queue =
        item.queueDetails && !Array.isArray(item.queueDetails)
          ? item.queueDetails
          : {};

      const partner =
        item.partnerDetails && !Array.isArray(item.partnerDetails)
          ? item.partnerDetails
          : {};

      const isNewPatient =
        item.is_presented === "No" &&
        (!item.queueDetails ||
          Array.isArray(item.queueDetails) ||
          Object.keys(queue).length === 0);

      const mark = queue.patient_marked || "Waiting";
      const dob = isNewPatient ? item.date_of_birth : queue.date_of_birth;
      const patient_id = queue.patient_id || item.patient_id || null;
      const queue_id = queue.queue_id || null;

      return {
        id: item.appointment_id,
        appointment_id: item.appointment_id,
        queue_id: queue_id,
        token_no: isNewPatient ? item.token_no || "0" : queue.token_no || "0",
        patient_marked: mark,
        is_payment: isNewPatient ? item.is_payment || "No" : queue.is_payment || "No",
        is_emergency: queue.is_emergency || "No",
        is_pause: queue.is_pause || "No",
        questionnaire_filled: !isNewPatient && queue.questionnaire_filled 
          ? queue.questionnaire_filled 
          : item.questionnaire_filled || "No",
        systolic_bp: !isNewPatient ? queue.systolic_bp : null,
        diastolic_bp: !isNewPatient ? queue.diastolic_bp : null,
        bmi: !isNewPatient ? queue.bmi : null,
        pluse_rate: !isNewPatient ? queue.pluse_rate : null,
        temperature: !isNewPatient ? queue.temperature : null,
        Oxygen_Saturation: !isNewPatient ? queue.Oxygen_Saturation : null,
        blood_glucose_level: !isNewPatient ? queue.blood_glucose_level : null,
        Allergies: !isNewPatient ? queue.Allergies : null,
        Reports_Upload: !isNewPatient ? queue.Reports_Upload : null,
        height: !isNewPatient ? queue.height : null,
        weight: !isNewPatient ? queue.weight : null,
        gender: !isNewPatient && queue.gender ? queue.gender : item.gender || "N/A",
        occupation: !isNewPatient && queue.occupation ? queue.occupation : item.occupation || "",
        whatsapp_contact_no: !isNewPatient && queue.whatsapp_contact_no
          ? queue.whatsapp_contact_no
          : item.phone_no || "",
        date_of_birth: dob || null,
        doctor: !isNewPatient && queue.doctor_name ? queue.doctor_name : item.doctor_name || "N/A",
        doctor_id: item.doctor_id,
        marital_status: !isNewPatient && queue.is_married
          ? queue.is_married === "Yes" ? "Married" : "Not Married"
          : item.is_married === "Yes" ? "Married" : "Not Married",
        patient_photo: !isNewPatient && queue.patient_photo ? queue.patient_photo : item.patient_photo || null,
        attend_status: item.appointment_visited === "Yes" ? "Attended" : "Not Attended",
        is_firsttime_visitor: item.is_firsttime_visitor || "No",
        is_presented: item.is_presented || "No",
        showReminder: item.appointment_visited !== "Yes",
        name: !isNewPatient && queue.first_name
          ? `${queue.first_name || ""} ${queue.middile_name || ""} ${queue.last_name || ""}`.trim()
          : item.patient_name || item.patient_full_name || "N/A",
        diseases: item.diseases || "-",
        date: item.date || "-",
        timeSlot: item.time_slot || "-",
        mode: item.mode || "-",
        status: mark,
        partner_id: partner?.patient_id || null,
        partner_name: partner?.first_name
          ? `${partner.first_name} ${partner.last_name || ""}`.trim()
          : "",
        partner_phone: partner?.whatsapp_contact_no || partner?.additional_contact_no || "",
        patient_id: patient_id,
        phone: !isNewPatient && queue.whatsapp_contact_no
          ? queue.whatsapp_contact_no
          : item.phone_no || "-",
        email: queue.patient_email || item.email || "-",
        branch: item.branch_name || "-",
        showCollectButton: !isNewPatient
          ? queue.is_payment === "No"
          : item.is_payment === "No",
        showReceiptIcon: !isNewPatient
          ? queue.is_payment === "Yes"
          : item.is_payment === "Yes",
        receipt_download_link: !isNewPatient
          ? queue.receipt_download_link || null
          : item.receipt_download_link || null,
        payment_id: patient_id,
        is_new_patient: isNewPatient,
        appointment_type: item.appointment_type,
        lead_id: item.lead_id || queue.lead_id,
        rescheduled_cnt: item.rescheduled_cnt || "0",
        telecaller_note: item.telecaller_note,
        cancellation_note: item.cancellation_note,
        age: dob ? new Date().getFullYear() - new Date(dob).getFullYear() : null
      };
    })
    .filter(item => item.patient_marked !== "Cancel")
    .sort((a, b) => {
      const order = { Current: 1, Next: 2, Waiting: 3 };
      return (order[a.status] || 99) - (order[b.status] || 99);
    });
}